
import { useState } from 'react';
import Hero from './components/Hero';
import About from './components/About';
import Services from './components/Services';
import WhySYG from './components/WhySYG';
import Contact from './components/Contact';
import Footer from './components/Footer';
import Navigation from './components/Navigation';

export default function Home() {
  const [isNavVisible, setIsNavVisible] = useState(false);

  return (
    <div className="bg-white">
      <Navigation isVisible={isNavVisible} setIsVisible={setIsNavVisible} />
      <Hero />
      <About />
      <Services />
      <WhySYG />
      <Contact />
      <Footer />
    </div>
  );
}
